import React, { Component } from "react";
import "./App.css";

import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Kitchen from "./pages/Kitchen";
import Room from "./pages/Room";
import Bedroom from "./pages/Bedroom";
import Hall from "./pages/Hall";
import Bathroom from "./pages/Bathroom";
import Other from "./pages/Other";
import SingleProject from "./pages/SingleProject";
import Error from "./pages/Error";
import Mailsent from "./pages/Mailsent";
import Telsent from "./pages/Telsent";

import { Route, Switch } from "react-router-dom";
// import ServicesTelsent from './components/ServicesTelsent';

class App extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/projekty/" component={Projects} />
          <Route exact path="/projekty/kuchyne" component={Kitchen} />
          <Route exact path="/projekty/pokoje" component={Room} />
          <Route exact path="/projekty/loznice" component={Bedroom} />
          <Route exact path="/projekty/predsine" component={Hall} />
          <Route exact path="/projekty/koupelny" component={Bathroom} />
          <Route exact path="/projekty/ostatni" component={Other} />
          <Route exact path="/projekty/:slug" component={SingleProject} />
          <Route exact path="/odeslano" component={Mailsent} />
          <Route exact path="/cislo" component={Telsent} />
          <Route component={Error} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js